export default __webpack_public_path__ + "static/full-img-d9ab02a97a6765fc708fc70148abddf7.jpg";